import {
	ENVIRONMENT_KEYS
} from "../components/elements/types/enviroment/enviroment-type";

class ConfigService {
	constructor() {
		this.config = {};
		this._loaded = false;
		this._loading = null;
	}

	async load() {
		if (this._loaded) return this.config;
		if (this._loading) return this._loading;

		this._loading = (async () => {
			let runtimeConfig = null;
			try {
				const res = await fetch('/config/config.json?ts=' + Date.now(), {
					cache: 'no-store'
				});
				if (!res.ok) throw new Error('HTTP ' + res.status);

				runtimeConfig = await res.json()
			} catch (e) {
				console.warn('[config] runtime config NOT found, using local ENVIRONMENT_KEYS for URLs', e);
				runtimeConfig = null;
			}

			const sensitiveConfig = {
				VITE_TOKEN_HISTORIC: ENVIRONMENT_KEYS.VITE_TOKEN_HISTORIC,
				VITE_TOKEN_VOLUMETRACKER: ENVIRONMENT_KEYS.VITE_TOKEN_VOLUMETRACKER,
				VITE_TOKEN_PARAMETERS: ENVIRONMENT_KEYS.VITE_TOKEN_PARAMETERS,
				VITE_TOKEN_IOT: ENVIRONMENT_KEYS.VITE_TOKEN_IOT,
				VITE_TOKEN_PROCESS: ENVIRONMENT_KEYS.VITE_TOKEN_PROCESS,
				VITE_TOKEN_FORECAST_UPLOAD: ENVIRONMENT_KEYS.VITE_TOKEN_FORECAST_UPLOAD,
				VITE_TOKEN_FORECAST_RUN: ENVIRONMENT_KEYS.VITE_TOKEN_FORECAST_RUN,
				VITE_TOKEN_FORECAST_OUTPUT: ENVIRONMENT_KEYS.VITE_TOKEN_FORECAST_OUTPUT,
				VITE_TOKEN_PLOTTING: ENVIRONMENT_KEYS.VITE_TOKEN_PLOTTING,
				VITE_TOKEN_PARAMETERS_PLOTTING: ENVIRONMENT_KEYS.VITE_TOKEN_PARAMETERS_PLOTTING,
				VITE_TOKEN_SCREENING: ENVIRONMENT_KEYS.VITE_TOKEN_SCREENING,
				VITE_TOKEN_ALERTS: ENVIRONMENT_KEYS.VITE_TOKEN_ALERTS,
				VITE_TOKEN_PRODUCTION_TEST: ENVIRONMENT_KEYS.VITE_TOKEN_PRODUCTION_TEST,
				VITE_TOKEN_EMISSIONS: ENVIRONMENT_KEYS.VITE_TOKEN_EMISSIONS,
				VITE_API_KEY_MAP: ENVIRONMENT_KEYS.VITE_API_KEY_MAP,
				VITE_TOKEN_AI_TRENDING: ENVIRONMENT_KEYS.VITE_TOKEN_AI_TRENDING,
				VITE_TOKEN_SETTINGS: ENVIRONMENT_KEYS.VITE_TOKEN_SETTINGS,
				VITE_TOKEN_PANEL_ALARMS: ENVIRONMENT_KEYS.VITE_TOKEN_PANEL_ALARNS,
			};

			// Helper para preferir runtime si existe, si no ENVIRONMENT_KEYS
			const pick = (key) =>
				(runtimeConfig && runtimeConfig[key] != null ? runtimeConfig[key] : ENVIRONMENT_KEYS[key]);

			// 🌐 URLs (no sensibles)
			const urlConfig = {
				VITE_PORT_DB: pick('VITE_PORT_DB'),
				VITE_PORT_ACCESS_CONTROL: pick('VITE_PORT_ACCESS_CONTROL'),
				VITE_PORT_FILTERS:	pick('VITE_PORT_FILTERS'),
				VITE_SSO_LOGIN_URL: pick('VITE_SSO_LOGIN_URL'),
				VITE_BASE_URL_PARAMETERS_WELL: pick('VITE_BASE_URL_PARAMETERS_WELL'),
				VITE_FILE_FORECAST: pick('VITE_FILE_FORECAST'),
				VITE_RUN_FORECAST: pick('VITE_RUN_FORECAST'),
				VITE_OUTPUT_FORECAST: pick('VITE_OUTPUT_FORECAST'),
				VITE_BASE_URL_DATA_HISTORY_DCA: pick('VITE_BASE_URL_DATA_HISTORY_DCA'),
				VITE_BASE_URL_DATA_HISTORY_GASLIFT: pick('VITE_BASE_URL_DATA_HISTORY_GASLIFT'),
				VITE_BASE_URL_DATA_HISTORY_AITRENDING: pick('VITE_BASE_URL_DATA_HISTORY_AITRENDING'),
				VITE_BASE_URL_DATA_HISTORY_PLUNGER_LIFT: pick('VITE_BASE_URL_DATA_HISTORY_PLUNGER_LIFT'),
				VITE_BASE_URL_DATA_HISTORY_INJECTOR: pick('VITE_BASE_URL_DATA_HISTORY_INJECTOR'),
				VITE_BASE_URL_IOT: pick('VITE_BASE_URL_IOT'),
				VITE_BASE_URL_PROCESS: pick('VITE_BASE_URL_PROCESS'),
				VITE_BASE_URL_PLOTTING: pick('VITE_BASE_URL_PLOTTING'),
				VITE_BASE_ULR_SCREENING_TOOL: pick('VITE_BASE_ULR_SCREENING_TOOL'),
				VITE_BASE_URL_CASING_PRESSURE: pick('VITE_BASE_URL_CASING_PRESSURE'),
				VITE_BASE_URL_VOLUMETRACKER: pick('VITE_BASE_URL_VOLUMETRACKER'),
				VITE_BASE_URL_PARAMETERS_PLOTTING: pick('VITE_BASE_URL_PARAMETERS_PLOTTING'),
				VITE_BASE_URL_ALERTS_MAP: pick('VITE_BASE_URL_ALERTS_MAP'),
				VITE_BASE_URL_MULTI_WELL: pick('VITE_BASE_URL_MULTI_WELL'),
				VITE_BASE_URL_PRODUCTION_TEST: pick('VITE_BASE_URL_PRODUCTION_TEST'),
				VITE_BASE_ULR_EMISSIONS: pick('VITE_BASE_ULR_EMISSIONS'),
				VITE_BASE_URL_AI_TRENDING: pick('VITE_BASE_URL_AI_TRENDING'),
				VITE_BASE_URL_SETTINGS: pick('VITE_BASE_URL_SETTINGS'),
				VITE_BASE_URL_PANEL_ALARMS: pick('VITE_BASE_URL_PANEL_ALARMS'),
				VITE_URL_TAG_SEARCH: pick('VITE_URL_TAG_SEARCH'),
			};

			this.config = {
				...urlConfig,
				...sensitiveConfig,
			};

			this._loaded = true;
			return this.config;
		})();

		return this._loading;
	}

	get(key, fallback = null) {
		return this._loaded ? (this.config?. [key] ?? fallback ?? null) : (fallback ?? null);
	}
}

export const configService = new ConfigService();
